module.exports = __webpack_public_path__ + "img/gatheringLocation.1eaef6cf.svg";